import { render, staticRenderFns } from "./dlg-post-save.vue?vue&type=template&id=f49e20a2&"
import script from "./dlg-post-save.vue?vue&type=script&lang=js&"
export * from "./dlg-post-save.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports